import { ButtonView, Plugin } from 'ckeditor5'
import { CutCommand } from './CutCommand'

export class CutPlugin extends Plugin {
  static get pluginName() {
    return 'Cut'
  }

  init() {
    const editor = this.editor

    // Add the cut command
    editor.commands.add('cut', new CutCommand(editor))

    // Add the cut button to the toolbar
    editor.ui.componentFactory.add('cut', (locale) => {
      const command = editor.commands.get('cut')
      const buttonView = new ButtonView(locale)
      buttonView.set({
        label:
          global.window.CKEDITOR_TRANSLATIONS[locale.contentLanguage]
            ?.dictionary?.Cut,
        icon: '<svg></svg>',
        tooltip: true,
      })

      if (command) {
        buttonView.bind('isEnabled').to(command, 'isEnabled')
      }

      buttonView.on('execute', () => {
        editor.execute('cut')
      })

      return buttonView
    })
  }
}
